import { render, staticRenderFns } from "./KBDP.vue?vue&type=template&id=9991bc56&lang=pug&"
import script from "./KBDP.vue?vue&type=script&lang=js&"
export * from "./KBDP.vue?vue&type=script&lang=js&"
import style0 from "./KBDP.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports